import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { toast } from "react-toastify";

const ProtectedRoute = ({ adminToken }) => {
  if (adminToken === null) {
    toast.error("You are not authorized to access this page.");
    return <Navigate to={"/admin/login"} />;
  } else {
    return <Outlet />;
  }
};

export default ProtectedRoute;
